import {Component} from '@angular/core';

@Component({
  selector: 'bb-manager-empty',
  templateUrl: './manager-empty.component.html',
  styleUrls: ['./manager-empty.component.scss'],
})
export class ManagerEmptyComponent {
}
